var _path, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChineseFlag = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "china 1",
    clipPath: "url(#clip0_3430_18717)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.5 0H2.5C1.39543 0 0.5 0.89543 0.5 2V10C0.5 11.1046 1.39543 12 2.5 12H10.5C11.6046 12 12.5 11.1046 12.5 10V2C12.5 0.89543 11.6046 0 10.5 0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3430_18717",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 13,
    height: 12
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.5 0H2.5C1.39543 0 0.5 0.89543 0.5 2V10C0.5 11.1046 1.39543 12 2.5 12H10.5C11.6046 12 12.5 11.1046 12.5 10V2C12.5 0.89543 11.6046 0 10.5 0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3430_18717)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.5 0H0.5V12H12.5V0Z",
    fill: "#F1361D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.81689 1.86062L5.23194 1.95968L5.54323 2.35658L5.61399 1.77551L5.89749 1.33971L5.48244 1.24065L5.17115 0.84375L5.10039 1.42482L4.81689 1.86062ZM5.92864 3.89278L6.2883 3.58633L6.70923 3.59996L6.49035 3.09644L6.50007 2.50714L6.14041 2.81359L5.71949 2.79996L5.93838 3.30349L5.92864 3.89278ZM5.44072 7.18244L5.08891 7.50628L5.08395 6.91687L4.85264 6.42434L5.27365 6.4174L5.62545 6.09356L5.63041 6.68297L5.86172 7.1755L5.44072 7.18244ZM5.74623 5.65899L6.16471 5.59405L6.54208 5.85545L6.49569 5.26959L6.68241 4.74127L6.26393 4.80621L5.88656 4.54481L5.93295 5.13067L5.74623 5.65899Z",
    fill: "#FFDC42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.35743 4.9361L2.3498 5.94174L2.72158 4.28934L1.72705 3.25846L2.96445 3.24286L3.35743 1.6001L3.75041 3.24286L4.98781 3.25846L3.99328 4.28934L4.36506 5.94174L3.35743 4.9361Z",
    fill: "#FFDC42"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3430_18717"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChineseFlag);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ChineseFlag.5f798b8f4af299309c6dfc7cdb414144.svg";